// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__AwFy-","image":"Header_image__1Y425","name":"Header_name__2Cy2u","info":"Header_info__2y55M","infoRow":"Header_infoRow__3WTds"};